export default __webpack_public_path__ + "static/media/chocolate_chips.b5664cea.jpeg";